<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardBody>
                    <OtherDeliveryTabLinks />
                    <OtherDeliveryCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/other-delivery`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import OtherDeliveryTabLinks from '@/components/other-delivery/OtherDeliveryTabLinks';
    import OtherDeliveryCard from '@/components/other-delivery/OtherDeliveryCard';

    export default {
        name: 'OtherDelivery',

        components: {
            OtherDeliveryTabLinks,
            OtherDeliveryCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/other-delivery/${id}`)).data;
            },
        },
    };
</script>
